import React, { useState, useEffect } from "react";
import InfoIcon from "./../../../../assets/images/icon-info.svg";
import { AlertModal } from "../../../../setup/alert/swalAlert";
import { alertIconType } from "../../../../setup/alert/iconTypes";
import useLangTranslation from "../../../customHooks/languageProvider";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { securityFilter } from "../../../../utils/securityFilter";
import {
  createTask as createTaskApi,
  removeTaskItems,
} from "../../AxiosRtk/Tasks";
import LoadingIndicator from "../../../../setup/Loader/LoaderIndicator";
import { setShowInfo } from "../../AxiosRtk/successMessage";

const CreateNewTask = (props) => {
  const dispatch = useDispatch();
  const { getLangTranslation } = useLangTranslation();
  const [kidSelection, setKidSelection] = useState({
    value: [],
    error: "",
    errTrans: "",
  });
  console.log("kidSelection", kidSelection);
  
  const [taskName, setTaskName] = useState({
    value: "",
    error: "",
    errTrans: "",
  });
  const [taskDetail, setTaskDetail] = useState({
    value: "",
    error: "",
    errTrans: "",
  });
  const [time, setTime] = useState({
    startTime: { value: "", error: "" },
    endTime: { value: "", error: "" },
  });
  const [createTask, setCreateTask] = useState({
    PROOF_REQUIRED: false,
    PROOF_NOT_REQUIRED: false,
    AUTOMATIC_CHILD: false,
    PARENT_UNLOCK: false,
  });
  const [isTaskCreateErrorShow, setTaskCreateErrorShow] = useState(false);
  const [options, setOptions] = useState([]);
  const [loader, setLoader] = useState(false);
  const history = useHistory();


  const { kidList, selectedKidId } = useSelector(({ dashboard }) => dashboard);
  const { editTaskDetails } = useSelector(({ tasks }) => tasks);
  
  function showReadMoreArticle(active) {
    if (active === "PARENT_ADD_TASK_PROOF_REQUIRED") {
      {
        /* AlertModal(
        getLangTranslation(
          "PARENT_ADD_TASK_INFO_PROOF_REQUIRED",
          "When you choose this option, the child will be able to use his device normally according to the house rules, the app will request the child for proof of task execution."
        ),
        alertIconType?.infoIcon,
        true,
        getLangTranslation(
          "PARENT_ADD_TASK_PROOF_REQUIRED",
          "Proof required / Child's device not locked"
        ),
        getLangTranslation("SELECT_CHILD_GOT_IT", "GOT IT")
        );*/
      }

      dispatch(
        setShowInfo({
          showInfo: true,
          defaultMessage:
            "When you choose this option, the child will be able to use his device normally according to the house rules, the app will request the child for proof of task execution.",
          message: "PARENT_ADD_TASK_INFO_PROOF_REQUIRED",
          title: "PARENT_ADD_TASK_PROOF_REQUIRED",
          defaultTitle: "Proof required / Child's device not locked",
        })
      );
    } else if (active === "PARENT_ADD_TASK_AUTO_DEVICE_UNLOCK") {
      {
        /*  AlertModal(
        getLangTranslation(
          "PARENT_ADD_TASK_INFO_AUTO_DEVICE_UNLOCK",
          "When you choose this option, the device will be locked and the child will not be able to use it until he finishes this task. Once the child finished his task, the phone will be automatically unlocked. In the locking time, your child will only be able to use the allowed apps on sections: Set Rules/Time supervision/Allowed apps."
        ),
        alertIconType?.infoIcon,
        true,
        getLangTranslation(
          "PARENT_ADD_TASK_AUTO_DEVICE_UNLOCK",
          "Automatic child's device unlock"
        ),
        getLangTranslation("SELECT_CHILD_GOT_IT", "GOT IT")
        );*/
      }

      dispatch(
        setShowInfo({
          showInfo: true,
          defaultMessage:
            "When you choose this option, the device will be locked and the child will not be able to use it until he finishes this task. Once the child finished his task, the phone will be automatically unlocked. In the locking time, your child will only be able to use the allowed apps on sections: Set Rules/Time supervision/Allowed apps.",
          message: "PARENT_ADD_TASK_INFO_AUTO_DEVICE_UNLOCK",
          title: "PARENT_ADD_TASK_AUTO_DEVICE_UNLOCK",
          defaultTitle: "Automatic child's device unlock",
        })
      );
    } else if (active === "PARENT_ADD_TASK_MANUAL_DEVICE_UNLOCK") {
      {
        /* AlertModal(
        getLangTranslation(
          "PARENT_ADD_TASK_INFO_MANUAL_DEVICE_UNLOCK",
          "When you choose this option, the device will be locked and the child will not be able to use it until you unlock his device manually by confirming the task. In the locking time, your child will only be able to use the allowed apps on sections: Set Rules/ Time supervision/Allowed apps."
        ),
        alertIconType?.infoIcon,
        true,
        getLangTranslation(
          "PARENT_ADD_TASK_MANUAL_DEVICE_UNLOCK",
          "Parent unlock child's device manually"
        ),
        getLangTranslation("SELECT_CHILD_GOT_IT", "GOT IT")
        );*/
      }

      dispatch(
        setShowInfo({
          showInfo: true,
          defaultMessage:
            "When you choose this option, the device will be locked and the child will not be able to use it until you unlock his device manually by confirming the task. In the locking time, your child will only be able to use the allowed apps on sections: Set Rules/ Time supervision/Allowed apps.",
          message: "PARENT_ADD_TASK_INFO_MANUAL_DEVICE_UNLOCK",
          title: "PARENT_ADD_TASK_MANUAL_DEVICE_UNLOCK",
          defaultTitle: "Parent unlock child's device manually",
        })
      );
    }
  }

  const isDevicesAvailable = kidList && selectedKidId
    ? kidList.find(kid => kid?.ID === selectedKidId)?.KidsDevices?.[0]?.Name
    : null;

    console.log("");
    

  useEffect(() => {
    const tempOpt = [];
    kidList.forEach((item) => {
      if(item?.KidsDevices.some(i => i?.KidsDeviceId)){
        tempOpt.push({ value: item?.ID, label: item?.childName });
      }      
    });
    setOptions(tempOpt);
    
    const kid = kidList.find((element) => element.ID === selectedKidId);

    setKidSelection({
      ...kidSelection,
      value: [{ value: kid?.ID, label: kid?.childName }],
    });
  }, [kidList]);

  useEffect(() => {
    if (props?.location?.pathname === "/edit-task" && editTaskDetails) {
      setTaskName({
        ...taskName,
        value: editTaskDetails?.taskName,
      });
      setTaskDetail({
        ...taskDetail,
        value: editTaskDetails?.taskDetail,
      });
      setTime({
        startTime: { value: editTaskDetails?.taskStartTime, error: "" },
        endTime: { value: editTaskDetails?.taskEndTime, error: "" },
      });
      // setCreateTask({

      // })
    } else if (props?.location?.pathname === "/edit-task" && !editTaskDetails) {
      history.push("/create-new-task");
    }
  }, [editTaskDetails]);

  function handleSelectChange(selectedKidData) {
    setKidSelection({ value: selectedKidData, error: "" });
  }

  function handleInputChange(e) {
    const { name, value } = e.target;
    if (name === "taskName") {
      setTaskName({ value, error: "" });
    } else if (name === "taskDetail") {
      setTaskDetail({ value, error: "" });
    } else if (name === "from") {
      setTime({
        ...time,
        startTime: { value, error: "" },
      });
    } else if (name === "to") {
      setTime({
        ...time,
        endTime: {
          value,
          error: "",
        },
      });
    }
  }

  function isValidateForm() {
    let flag = true;

    if (kidSelection?.value?.length === 0) {
      setKidSelection({
        ...kidSelection,
        error: "PLEASE_SELECT_CHILD_ERR_TXT",
        errTrans: "Please select child",
      });
      flag = false;
    }

    if (!taskName.value) {
      setTaskName({
        ...taskName,
        error: "PARENT_TASK_EMPTY_TASK_NAME",
        errTrans: "Please enter task name",
      });
      flag = false;
    } else if (taskName.value && !securityFilter(taskName.value)) {
      setTaskName({
        ...taskName,
        error: "SPECIAL_CHAR_NOT_ALLOWED_ERR",
        errTrans: "Special characters are not allowed",
      });
      flag = false;
    }

    if (!taskDetail.value) {
      setTaskDetail({
        ...taskDetail,
        error: "PARENT_TASK_EMPTY_TASK_DETAILS",
        errTrans: "Please enter task details",
      });
      flag = false;
    } else if (taskDetail?.value && !securityFilter(taskName.value)) {
      setTaskDetail({
        ...taskDetail,
        error: "SPECIAL_CHAR_NOT_ALLOWED_ERR",
        errTrans: "Special characters are not allowed",
      });
      flag = false;
    }

    if (!createTask?.PROOF_REQUIRED && !createTask?.AUTOMATIC_CHILD && !createTask?.PROOF_NOT_REQUIRED && !createTask?.PARENT_UNLOCK) {
      flag = false;
      setTaskCreateErrorShow(true);
    }

    return flag;
  }

  function proofRequiedStatus() {
    if (createTask?.PROOF_REQUIRED) {
      return 1;
    }
    return 0;
  }

  function handleSave() {
    if (!isValidateForm()) {
      return;
    }

    setLoader(true);

    let payload = null;

    if (props?.location?.pathname === "/edit-task") {
      payload = {
        isTaskEditMode: 1,
        kidId: kidSelection?.value?.map((item) => item?.value),
        isTaskEditMode: 1,
        appDeviceUnlock: createTask?.AUTOMATIC_CHILD ? 1 : 0,
        appLock: 0,
        deviceLock: createTask?.PARENT_UNLOCK ? 1 : 0,
        manuallyParent: 0,
        proofRequired: proofRequiedStatus(),
        taskDetail: taskDetail?.value,
        taskId: editTaskDetails?.taskId,
        taskName: taskName?.value,
        startTime: time?.startTime?.value,
        endTime: time?.endTime?.value,
      };
    } else {
      payload = {
        kidId: kidSelection?.value?.map((item) => item?.value),
        taskName: taskName?.value,
        taskDetail: taskDetail?.value,
        appLock: 0,
        deviceLock: 0,
        proofRequired: proofRequiedStatus(),
        appDeviceUnlock: createTask?.AUTOMATIC_CHILD ? 1 : 0,
        manuallyParent: createTask?.PARENT_UNLOCK ? 1 : 0,
        isTaskEditMode: 0,
        startTime: time?.startTime?.value,
        endTime: time?.endTime?.value,
      };
    }

    createTaskApi(payload)
      .then((res) => {        
        history.push("/tasks");
      })
      .catch((err) => {
        AlertModal(getLangTranslation(err?.response?.data?.message, err?.response?.data?.message), alertIconType?.errorIcon, true)
      })
      .finally(() => {
        setLoader(false);
        if (props?.location?.pathname === "/edit-task") {
          dispatch(removeTaskItems("EDIT_TASK_DETAILS"));
        }
      });
  }

  return (
    <>
      <div className="card">
        <div className="card-body">
          {props?.location?.pathname !== "/edit-task" ? (
            <>
              <h3
                className="text-blue-900 mb-0 c-pointer"
                onClick={() => history.goBack()}
              >
                <i className="icon-arrow-left" />
                {getLangTranslation("CREATE_NEW_TASK", "Create new task")}
              </h3>
            </>
          ) : (
            <>
              <h3
                className="text-blue-900 mb-0 c-pointer"
                onClick={() => history.goBack()}
              >
                <i className="icon-arrow-left" />
                {getLangTranslation("EDIT_TASK", "Edit task")}
              </h3>
            </>
          )}

          {/* Edit_task */}
          <hr className="my-6" />
          <div className="content-550 mx-auto">
            {props?.location?.pathname !== "/edit-task" && (
              <div className="mb-6">
                {/* <label htmlFor="selectName" className="form-label">Select a child</label>
                            <select className="form-select" id="selectName">
                                <option>Select</option>
                                <option value="male">Emma</option>
                                <option value="female">Female</option>
                            </select> */}
                <label htmlFor="kidSelection" className="form-label">
                  {getLangTranslation(
                    "PARENT_NOTIFICATION_FILTER_SELECT_KID",
                    "Select child"
                  )}
                </label>
                <Select
                  // defaultValue={kidSelection}
                  className='custom-select'
                  classNamePrefix='custom-select'
                  placeholder={getLangTranslation(
                    "PARENT_NOTIFICATION_FILTER_SELECT_KID",
                    "Select child"
                  )}
                  onChange={handleSelectChange}
                  isMulti={true}
                  options={options}
                  id="kidSelection"
                  name="kidSelection"
                  value={kidSelection?.value}
                />
                {kidSelection?.error && (
                  <div className="field-error">
                    {getLangTranslation(
                      kidSelection?.error,
                      kidSelection?.errTrans
                    )}
                  </div>
                )}
              </div>
            )}

            <div className="mb-6">
              <label htmlFor="taskName" className="form-label">
                {getLangTranslation("PARENT_ADD_TASK_TASK_NAME", "Task name")}
              </label>
              {/* <select className="form-select" id="taskName">
                                <option>Please enter task name</option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                            </select> */}
              <input
                type="text"
                name="taskName"
                className="form-control"
                id="taskName"
                value={taskName?.value}
                placeholder={getLangTranslation(
                  "PARENT_ADD_TASK_TASK_NAME",
                  "Task name"
                )}
                onChange={handleInputChange}
              />
              {taskName?.error && (
                <div className="field-error">
                  {getLangTranslation(taskName?.error, taskName?.errTrans)}
                </div>
              )}
            </div>
            <div className="mb-6">
              <label htmlFor="taskDetail" className="form-label">
                {getLangTranslation(
                  "PARENT_ADD_TASK_TASK_DETAILS",
                  "Task details"
                )}
              </label>
              <textarea
                className="form-control"
                id="taskDetail"
                rows="3"
                value={taskDetail?.value}
                name="taskDetail"
                onChange={handleInputChange}
              ></textarea>
              {taskDetail?.error && (
                <div className="field-error">
                  {getLangTranslation(taskDetail?.error, taskDetail?.errTrans)}
                </div>
              )}
            </div>
            <h5 className="mb-3">
              {getLangTranslation(
                "SET_TIME_LIMIT_FOR_TASK",
                "Set a time limit for the task"
              )}
            </h5>
            <div className="row">
              <div className="col-md-6">
                <div className="mb-6">
                  <label htmlFor="from" className="form-label">
                    From
                  </label>
                  <input
                    type="time"
                    className={`form-control ${time?.startTime?.value ? "" : "time-placeholder"
                      }`}
                    id="from"
                    placeholder=""
                    name="from"
                    value={time?.startTime?.value || ""}
                    onChange={handleInputChange}
                  />
                  {time?.startTime?.error && (
                    <div className="field-error">
                      {getLangTranslation(time?.startTime?.error)}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-6">
                  <label htmlFor="to" className="form-label">
                    To
                  </label>
                  <input
                    type="time"
                    className={`form-control ${time?.startTime?.value ? "" : "time-placeholder"
                      }`}
                    id="to"
                    placeholder=""
                    name="to"
                    value={time?.endTime?.value || ""}
                    onChange={handleInputChange}
                  />
                  {time?.endTime?.error && (
                    <div className="field-error">
                      {getLangTranslation(time?.endTime?.error)}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* {props?.location?.pathname !== "/edit-task" && ( */}
              <>
                {
                  isTaskCreateErrorShow && (
                    <span className="d-inline-block my-3 text-danger">{getLangTranslation("PARENT_TASK_TYPE_NO_SELECTED_ERROR", "Please select one of the given options")}</span>
                  )
                }

                <div className="form-check mb-6 d-flex justify-content-between">
                  <div>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="createTask"
                      id="proofRequired"
                      checked={createTask?.PROOF_REQUIRED}
                      onChange={(e) => {
                        setCreateTask({
                          ...createTask,
                          PROOF_REQUIRED: e.target.checked,
                          PROOF_NOT_REQUIRED: false,
                          AUTOMATIC_CHILD: false,
                          PARENT_UNLOCK: false,
                        });
                        setTaskCreateErrorShow(false);
                      }}
                    />
                    <label className="form-check-label" htmlFor="proofRequired">
                      <h6 className="text-blue-900 mb-0">
                        {getLangTranslation(
                          "PARENT_ADD_TASK_PROOF_REQUIRED",
                          "Proof required / Child's device not locked"
                        )}
                      </h6>
                    </label>
                  </div>
                  <i
                    className="icon-info-one text-blue-400 fs-4 pt-cursor"
                    onClick={() =>
                      showReadMoreArticle("PARENT_ADD_TASK_PROOF_REQUIRED")
                    }
                  />
                </div>
                <div className="form-check mb-6 d-flex justify-content-between">
                  <div>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="createTask"
                      id="proofNotRequired"
                      checked={createTask?.PROOF_NOT_REQUIRED}
                      onChange={(e) => {
                        setCreateTask({
                          ...createTask,
                          PROOF_REQUIRED: false,
                          PROOF_NOT_REQUIRED: e.target.checked,
                          AUTOMATIC_CHILD: false,
                          PARENT_UNLOCK: false,
                        });
                        setTaskCreateErrorShow(false);
                      }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="proofNotRequired"
                    >
                      <h6 className="text-blue-900 mb-0">
                        {getLangTranslation(
                          "PARENT_ADD_TASK_PROOF_NOT_REQUIRED",
                          "Proof not required / Child's device not locked"
                        )}
                      </h6>
                    </label>
                  </div>
                  <i
                    className="icon-info-one text-blue-400 fs-4 pt-cursor"
                  // onClick={() =>
                  //   showReadMoreArticle("PROOF_REQUIRED")
                  //   }
                  />
                </div>
                <div className="form-check mb-6 d-flex justify-content-between">
                  <div>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="createTask"
                      id="childDeviceUnlock"
                      checked={createTask?.AUTOMATIC_CHILD}
                      onChange={(e) => {
                        setCreateTask({
                          ...createTask,
                          AUTOMATIC_CHILD: e.target.checked,
                          PROOF_REQUIRED: false,
                          PARENT_UNLOCK: false,
                        });
                        setTaskCreateErrorShow(false);
                      }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="childDeviceUnlock"
                    >
                      <h6 className="text-blue-900 mb-0">
                        {getLangTranslation(
                          "PARENT_ADD_TASK_AUTO_DEVICE_UNLOCK",
                          "Automatic child's device unlock"
                        )}
                      </h6>
                    </label>
                  </div>
                  <i
                    className="icon-info-one text-blue-400 fs-4 pt-cursor"
                    onClick={() =>
                      showReadMoreArticle("PARENT_ADD_TASK_AUTO_DEVICE_UNLOCK")
                    }
                  />
                </div>
                <div className="form-check mb-6 d-flex justify-content-between">
                  <div>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="createTask"
                      id="parentUnlock"
                      checked={createTask?.PARENT_UNLOCK}
                      onChange={(e) => {
                        setCreateTask({
                          ...createTask,
                          PARENT_UNLOCK: e.target.checked,
                          AUTOMATIC_CHILD: false,
                          PROOF_REQUIRED: false,
                        });
                        setTaskCreateErrorShow(false);
                      }}
                    />
                    <label className="form-check-label" htmlFor="parentUnlock">
                      <h6 className="text-blue-900 mb-0">
                        {getLangTranslation(
                          "PARENT_ADD_TASK_MANUAL_DEVICE_UNLOCK",
                          "Parent unlock child's device manually"
                        )}
                      </h6>
                    </label>
                  </div>
                  <i
                    className="icon-info-one text-blue-400 fs-4 pt-cursor"
                    onClick={() =>
                      showReadMoreArticle(
                        "PARENT_ADD_TASK_MANUAL_DEVICE_UNLOCK"
                      )
                    }
                  />
                </div>
              </>
            {/* )} */}

            <div className={`${loader ? "" : "grid gap-3"}`}>
              {loader ? (
                <div className="w-100 m-auto">
                  <LoadingIndicator height={20} width={100} color="#66B5FF" />
                </div>
              ) : (
                <>
                  <button
                    className="btn btn-primary g-col-6"
                    type="button"
                    onClick={handleSave}
                  >
                    <span className="btn-upper-case">Save</span>
                  </button>
                  <button
                    className="btn btn-outline-primary g-col-6"
                    type="button"
                    onClick={() => history.push("/tasks")}
                  >
                    <span className="btn-upper-case">Cancel</span>
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateNewTask;
